import _regeneratorRuntime from "@babel/runtime/regenerator";
import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import React, { useEffect, useState } from 'react';
import { Button, FormInput } from '../../../forms/elements';
import { Field } from 'formik';
import GiftCardField from './GiftCardField';

var GiftCardForm = function GiftCardForm(props, ref) {
  var _props$cart10, _props$cart10$price;

  var _useState = useState(''),
      _useState2 = _slicedToArray(_useState, 2),
      giftCardNumber = _useState2[0],
      setGiftCardNumber = _useState2[1];

  var _useState3 = useState(''),
      _useState4 = _slicedToArray(_useState3, 2),
      giftCardPin = _useState4[0],
      setGiftCardPin = _useState4[1];

  var _useState5 = useState(false),
      _useState6 = _slicedToArray(_useState5, 2),
      submitting = _useState6[0],
      setSubmitting = _useState6[1];

  var giftCardInfo = props.giftCardInfo,
      setGiftCardInfo = props.setGiftCardInfo,
      setPaymentType = props.setPaymentType,
      setFieldValue = props.setFieldValue,
      errors = props.errors,
      setFieldTouched = props.setFieldTouched;

  var giftCardNumberChangeHandler = function giftCardNumberChangeHandler(e) {
    setFieldValue('giftCardNumber', e);
    setGiftCardNumber(e);
  };

  var giftCardPinChangeHandler = function giftCardPinChangeHandler(e) {
    setFieldValue('giftCardPin', e);
    setGiftCardPin(e);
  };

  var handleSubmit = /*#__PURE__*/function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(event) {
      var _response, _response$GiftCardDet, _response2, _response2$GiftCardDe, response, _response3, _response3$Price, _response4, _response4$GiftCardDe, _response5, _response5$GiftCardDe, _response6, _response6$GiftCardDe, _response7, _response7$GiftCardDe, _response8, _response8$GiftCardDe;

      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              if (!submitting) {
                _context.next = 2;
                break;
              }

              return _context.abrupt("return");

            case 2:
              setSubmitting(true);
              _context.next = 5;
              return setFieldTouched('giftCardNumber', true);

            case 5:
              _context.next = 7;
              return setFieldTouched('giftCardPin', true);

            case 7:
              _context.prev = 7;

              if (!(!(errors === null || errors === void 0 ? void 0 : errors.giftCardNumber) && !(errors === null || errors === void 0 ? void 0 : errors.giftCardPin) && giftCardNumber && giftCardPin)) {
                _context.next = 12;
                break;
              }

              _context.next = 11;
              return props.getGiftCardBalance({
                'cardnumber': giftCardNumber,
                'pin': giftCardPin
              });

            case 11:
              response = _context.sent;

            case 12:
              if (((_response = response) === null || _response === void 0 ? void 0 : (_response$GiftCardDet = _response.GiftCardDetails) === null || _response$GiftCardDet === void 0 ? void 0 : _response$GiftCardDet.Success) && ((_response2 = response) === null || _response2 === void 0 ? void 0 : (_response2$GiftCardDe = _response2.GiftCardDetails) === null || _response2$GiftCardDe === void 0 ? void 0 : _response2$GiftCardDe.Balance) > 1) {
                if (((_response3 = response) === null || _response3 === void 0 ? void 0 : (_response3$Price = _response3.Price) === null || _response3$Price === void 0 ? void 0 : _response3$Price.Total) === 0) {
                  setGiftCardInfo({
                    status: 'applied-covers',
                    balance: (_response4 = response) === null || _response4 === void 0 ? void 0 : (_response4$GiftCardDe = _response4.GiftCardDetails) === null || _response4$GiftCardDe === void 0 ? void 0 : _response4$GiftCardDe.Balance,
                    message: (_response5 = response) === null || _response5 === void 0 ? void 0 : (_response5$GiftCardDe = _response5.GiftCardDetails) === null || _response5$GiftCardDe === void 0 ? void 0 : _response5$GiftCardDe.Message
                  });
                  setFieldValue('giftCardApplied', true);
                } else {
                  setGiftCardInfo({
                    status: 'applied-not-cover',
                    balance: (_response6 = response) === null || _response6 === void 0 ? void 0 : (_response6$GiftCardDe = _response6.GiftCardDetails) === null || _response6$GiftCardDe === void 0 ? void 0 : _response6$GiftCardDe.Balance,
                    message: (_response7 = response) === null || _response7 === void 0 ? void 0 : (_response7$GiftCardDe = _response7.GiftCardDetails) === null || _response7$GiftCardDe === void 0 ? void 0 : _response7$GiftCardDe.Message
                  });
                  setPaymentType('both');
                  setFieldValue('giftCardApplied', true);
                }
              } else {
                setGiftCardInfo({
                  status: 'error',
                  balance: 0,
                  message: (_response8 = response) === null || _response8 === void 0 ? void 0 : (_response8$GiftCardDe = _response8.GiftCardDetails) === null || _response8$GiftCardDe === void 0 ? void 0 : _response8$GiftCardDe.Message
                });
                setFieldValue('giftCardApplied', false);
              }

              setTimeout(function () {
                setSubmitting(false);
              }, 500);
              _context.next = 20;
              break;

            case 16:
              _context.prev = 16;
              _context.t0 = _context["catch"](7);
              setSubmitting(false);
              console.error('Error on Get Gift Card Balance request: ', _context.t0.message);

            case 20:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[7, 16]]);
    }));

    return function handleSubmit(_x) {
      return _ref.apply(this, arguments);
    };
  }();

  useEffect(function () {
    var _props$cart, _props$cart$price, _props$cart4, _props$cart4$price, _props$cart7, _props$cart7$price;

    if (((_props$cart = props.cart) === null || _props$cart === void 0 ? void 0 : (_props$cart$price = _props$cart.price) === null || _props$cart$price === void 0 ? void 0 : _props$cart$price.Total) > 0 && (giftCardInfo === null || giftCardInfo === void 0 ? void 0 : giftCardInfo.status) === 'applied-covers') {
      var _props$cart2, _props$cart2$GiftCard, _props$cart3, _props$cart3$GiftCard;

      setGiftCardInfo({
        status: 'applied-not-cover',
        balance: (_props$cart2 = props.cart) === null || _props$cart2 === void 0 ? void 0 : (_props$cart2$GiftCard = _props$cart2.GiftCardDetails) === null || _props$cart2$GiftCard === void 0 ? void 0 : _props$cart2$GiftCard.Balance,
        message: (_props$cart3 = props.cart) === null || _props$cart3 === void 0 ? void 0 : (_props$cart3$GiftCard = _props$cart3.GiftCardDetails) === null || _props$cart3$GiftCard === void 0 ? void 0 : _props$cart3$GiftCard.Message
      });
      setPaymentType('both');
    }

    if (((_props$cart4 = props.cart) === null || _props$cart4 === void 0 ? void 0 : (_props$cart4$price = _props$cart4.price) === null || _props$cart4$price === void 0 ? void 0 : _props$cart4$price.Total) > 0 && (giftCardInfo === null || giftCardInfo === void 0 ? void 0 : giftCardInfo.status) === 'applied-not-cover') {
      var _props$cart5, _props$cart5$GiftCard, _props$cart6, _props$cart6$GiftCard;

      setGiftCardInfo({
        status: 'applied-not-cover',
        balance: (_props$cart5 = props.cart) === null || _props$cart5 === void 0 ? void 0 : (_props$cart5$GiftCard = _props$cart5.GiftCardDetails) === null || _props$cart5$GiftCard === void 0 ? void 0 : _props$cart5$GiftCard.Balance,
        message: (_props$cart6 = props.cart) === null || _props$cart6 === void 0 ? void 0 : (_props$cart6$GiftCard = _props$cart6.GiftCardDetails) === null || _props$cart6$GiftCard === void 0 ? void 0 : _props$cart6$GiftCard.Message
      });
      setPaymentType('both');
    }

    if (((_props$cart7 = props.cart) === null || _props$cart7 === void 0 ? void 0 : (_props$cart7$price = _props$cart7.price) === null || _props$cart7$price === void 0 ? void 0 : _props$cart7$price.Total) === 0 && (giftCardInfo === null || giftCardInfo === void 0 ? void 0 : giftCardInfo.status) === 'applied-not-cover') {
      var _props$cart8, _props$cart8$GiftCard, _props$cart9, _props$cart9$GiftCard;

      setGiftCardInfo({
        status: 'applied-covers',
        balance: (_props$cart8 = props.cart) === null || _props$cart8 === void 0 ? void 0 : (_props$cart8$GiftCard = _props$cart8.GiftCardDetails) === null || _props$cart8$GiftCard === void 0 ? void 0 : _props$cart8$GiftCard.Balance,
        message: (_props$cart9 = props.cart) === null || _props$cart9 === void 0 ? void 0 : (_props$cart9$GiftCard = _props$cart9.GiftCardDetails) === null || _props$cart9$GiftCard === void 0 ? void 0 : _props$cart9$GiftCard.Message
      });
    }
  }, [(_props$cart10 = props.cart) === null || _props$cart10 === void 0 ? void 0 : (_props$cart10$price = _props$cart10.price) === null || _props$cart10$price === void 0 ? void 0 : _props$cart10$price.Total]);
  return /*#__PURE__*/React.createElement("div", {
    className: "gift-card-form"
  }, (giftCardInfo === null || giftCardInfo === void 0 ? void 0 : giftCardInfo.status) === 'error' && (giftCardInfo === null || giftCardInfo === void 0 ? void 0 : giftCardInfo.message) && /*#__PURE__*/React.createElement("div", {
    className: "is-error gift-card-form__global-error"
  }, giftCardInfo === null || giftCardInfo === void 0 ? void 0 : giftCardInfo.message), /*#__PURE__*/React.createElement(Field, {
    name: "giftCardNumber",
    label: "Gift Card Number",
    component: GiftCardField,
    className: "cb-form__input--full gift-card-form__input",
    changeHandler: giftCardNumberChangeHandler,
    type: "number",
    value: giftCardNumber,
    maxLength: 19
  }), /*#__PURE__*/React.createElement(Field, {
    name: "giftCardPin",
    label: "Pin",
    component: GiftCardField,
    className: "cb-form__input--full gift-card-form__input",
    changeHandler: giftCardPinChangeHandler,
    type: "number",
    maxLength: 4
  }), /*#__PURE__*/React.createElement(Button, {
    disabled: submitting,
    type: 'button',
    onClick: handleSubmit,
    className: "cb-button-primary btn-sm gift-card-form__submit"
  }, "Apply Gift Card"));
};

export default GiftCardForm;